export default __webpack_public_path__ + "8bcd75c806b3abb4d507ec428efe3a11.svg";